/* eslint-disable */ import { attributeSelectionComponent, composedOfComponent, genericDimensionComponent, memoEval, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Fabric, Inseam, Liner, Size } from '../model/index.js';
export const shortsComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Shorts').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$parts', true).withAlias('Shorts').attach(memoEval((self)=>self.$parts.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(genericDimensionComponent, 'inseam', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.inseam
        ], (inseam)=>({
            min: -1,
            max: 1,
            decimalPlaces: 1,
            unit: '"',
            value: inseam
        })), (state)=>{
        Inseam.assert(state.value);
        return {
            inseam: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'fabric', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.fabric
        ], (fabric)=>({
            options: [
                {
                    label: '90/10 stretch',
                    value: '90/10 stretch'
                },
                {
                    label: '96/4 stretch',
                    value: '96/4 stretch'
                }
            ],
            value: fabric
        })), (state)=>{
        Fabric.assert(state.value);
        return {
            fabric: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'liner', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.liner
        ], (liner)=>({
            options: [
                {
                    label: 'No liner',
                    value: 'none'
                },
                {
                    label: 'Leisure liner',
                    value: 'mesh'
                },
                {
                    label: 'Compression liner',
                    value: 'compression'
                }
            ],
            value: liner
        })), (state)=>{
        Liner.assert(state.value);
        return {
            liner: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'size', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.size
        ], (size)=>({
            options: [
                {
                    label: 'XS',
                    value: 'xs'
                },
                {
                    label: 'S',
                    value: 's'
                },
                {
                    label: 'M',
                    value: 'm'
                },
                {
                    label: 'L',
                    value: 'l'
                },
                {
                    label: 'XL',
                    value: 'xl'
                },
                {
                    label: '2XL',
                    value: '2xl'
                },
                {
                    label: '3XL',
                    value: '3xl'
                }
            ],
            value: size
        })), (state)=>{
        Size.assert(state.value);
        return {
            size: state.value
        };
    })
];

//# sourceMappingURL=shorts.js.map